import type { ReactNode } from 'react';
import { Box, Stack, Typography, type SvgIconProps } from '@mui/material';

interface EmptyStateProps {
  icon: React.ComponentType<SvgIconProps>;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  compact?: boolean;
}

/** Friendly placeholder for empty lists, disabled modules and restricted areas. */
export function EmptyState({ icon: Icon, title, description, action, compact }: EmptyStateProps) {
  return (
    <Stack
      spacing={1.5}
      sx={{ alignItems: 'center', textAlign: 'center', py: compact ? 4 : { xs: 6, md: 10 }, px: 2 }}
    >
      <Box
        sx={(theme) => ({
          width: compact ? 56 : 72,
          height: compact ? 56 : 72,
          borderRadius: compact ? 4 : 5,
          display: 'grid',
          placeItems: 'center',
          bgcolor: theme.vars.palette.primary.container,
          color: theme.vars.palette.primary.onContainer,
          mb: 1,
        })}
      >
        <Icon sx={{ fontSize: compact ? 28 : 36 }} />
      </Box>
      <Typography variant={compact ? 'h6' : 'h5'} component="h2">
        {title}
      </Typography>
      {description && (
        <Typography color="text.secondary" sx={{ maxWidth: 460 }}>
          {description}
        </Typography>
      )}
      {action && <Box sx={{ pt: 1 }}>{action}</Box>}
    </Stack>
  );
}
